const eventsList = [
  {
    event_id: 'grace-users',
    event_name: 'Grace Users',
  }, {
    event_id: 'active-users',
    event_name: 'Active Users',
  },
  {
    event_id: 'waitlist-users',
    event_name: 'Waitlist Users',
  },
  {
    event_id: 'waitdrop-users',
    event_name: 'WaitDrop Users',
  },
  {
    event_id: 'bounced-users',
    event_name: 'Bounced Users',
  },
  {
    event_id: 'expired-users',
    event_name: 'Deactivated Users',
  },
];

export default eventsList;
